<p-toast position="{{smallScreen ? 'bottom-right' : 'bottom-right'}}"></p-toast>

<div class="timesheet-page">

<p-confirmDialog #cd [style]="{width: '700px'}">
  <p-footer>
    <button type="button" pButton accesskey="y" icon="pi-fw fas fa-trash-alt" class="p-button-raised p-button-danger" label="Yes" (click)="cd.accept()"></button>
    <button type="button" pButton icon="pi pi-times" accesskey="n" class="p-button-raised p-button-outlined" label="No" (click)="cd.reject()"></button>
  </p-footer>
</p-confirmDialog>

<p-toolbar styleClass="p-shadow-2">
  <div class="p-toolbar-group-left">
    <p-breadcrumb [model]="items" class="p-d-none p-d-lg-inline"></p-breadcrumb>

    <span style="padding-top:2px;">
      <button pButton type="button" 
              class="p-button-rounded p-button-text p-button-primary button-icon-bold icon-large" 
              icon="pi pi-fw pi-refresh" 
              (click)="loadTimesheet()"></button>

      <!-- Display only on bigger than md screens-->
      <span class="p-d-none p-d-md-inline">
        <button *ngIf="canEnterTimeSheet()" pButton type="button" 
                class="p-button p-button-text" 
                label="Enter Timesheet" 
                icon="pi-fw fas fa-plus-circle"
                (click)="manageTimesheet()"></button>

        <button *ngIf="canExportTimeSheet()" pButton type="button" 
                class="p-button p-button-text"
                label="Excel Report" 
                icon="{{exporting ? 'pi-fw fa fa-circle-o-notch fa-spin' : 'pi-fw fas fa-file-download'}}"
                (click)="exportTimesheet()"></button>

        <button *ngIf="canExportTimeSheet()" pButton type="button" 
                class="p-button p-button-text"
                label="Validation Report" 
                icon="{{exportingValidationReport ? 'pi-fw fa fa-circle-o-notch fa-spin' : 'pi-fw fas fa-file-download'}}"
                (click)="timesheetValidationReport()"></button>

        <button *ngIf="canModifyTimeSheet()" 
                (click)="openTimesheetForm(selectedRow)"
                [disabled]="selectedRow === null"
                pButton type="button" 
                class="p-button p-button-text" 
                label="Edit Timesheet" 
                icon="pi-fw fas fa-user-edit"></button>

        <button *ngIf="canModifyTimeSheet()" 
                (click)="deleteTimesheet(selectedRow);"
                [disabled]="selectedRow === null"
                pButton type="button" 
                class="p-button p-button-text" 
                label="Delete Timesheet"
                icon="pi-fw fas fa-trash"></button>

        <button *ngIf="canGenerateTimeSheet()" pButton type="button" 
                class="p-button p-button-text" 
                label="Generate Timesheet" 
                icon="pi-fw fas fa-tools"
                (click)="generateTimesheet()"></button>                
      </span>

      <!-- Display only on smaller than md screens-->
      <span class="p-d-md-none">
        <button *ngIf="canEnterTimeSheet()" pButton type="button" 
                class="p-button-rounded p-button-success" 
                icon="pi-fw fas fa-plus-circle"
                (click)="manageTimesheet()"></button>

        <button *ngIf="canExportTimeSheet()" pButton type="button" 
                class="p-button-rounded p-button-success" 
                icon="{{exporting ? 'pi-fw fa fa-circle-o-notch fa-spin' : 'pi-fw fas fa-file-download'}}"
                (click)="exportTimesheet()"></button>

        <button *ngIf="canExportTimeSheet()" pButton type="button" 
                class="p-button-rounded p-button-success" 
                icon="{{exportingValidationReport ? 'pi-fw fa fa-circle-o-notch fa-spin' : 'pi-fw fas fa-file-download'}}"
                (click)="timesheetValidationReport()"></button>
                
        <button *ngIf="canModifyTimeSheet()" 
                (click)="openTimesheetForm(selectedRow)"
                [disabled]="selectedRow === null"
                pButton type="button" 
                class="p-button-rounded p-button-success" 
                icon="pi-fw fas fa-edit"></button>

        <button *ngIf="canModifyTimeSheet()" 
                (click)="deleteTimesheet(selectedRow);"
                [disabled]="selectedRow === null"
                pButton type="button" 
                class="p-button-rounded p-button-danger" 
                icon="pi-fw fas fa-trash"></button>

        <button *ngIf="canGenerateTimeSheet()" 
                (click)="generateTimesheet();"
                pButton type="button" 
                class="p-button-rounded p-button-danger" 
                icon="pi-fw fas fa-tools"></button>
      </span>      
    </span>
  </div>
  
  <div class="p-toolbar-group-right">
    <i class="pi-fw far fa-bell p-mr-4 p-mt-2 p-text-secondary toolbar-badge-icon text-danger" pBadge 
        style="cursor:pointer" 
        severity="danger"
        pTooltip="Click to show the {{getCountOfMissingTimesheets()}} employees without timesheet logged"
        (click)="showMissingTimesheets()"
        value="{{getCountOfMissingTimesheets()}}"></i>

    <i class="pi-fw far fa-bell p-mr-4 p-mt-2 p-text-secondary toolbar-badge-icon text-warning" pBadge 
        style="cursor:pointer"
        severity="warning"
        pTooltip="Click to show the {{getCountOfTimesheetsWithWarning()}} timesheets with warnings"
        tooltipPosition="left"
        (click)="showTimesheetsWithWarning()"
        value="{{getCountOfTimesheetsWithWarning()}}"></i>
        
    <i class="pi-fw far fa-bell p-mr-4 p-mt-2 p-text-secondary toolbar-badge-icon text-primary" pBadge 
        style="cursor:pointer"
        severity="info"
        pTooltip="Click to show all {{getCountOfAllEnteredTimesheets()}} timesheets"
        tooltipPosition="left"
        (click)="showAllEnteredTimesheets()"
        value="{{getCountOfAllEnteredTimesheets()}}"></i>
  </div>
</p-toolbar>

<p-splitter class="timesheet-grid-area" styleClass="timesheet-splitter" [layout]="smallScreen ? 'vertical' : 'horizontal'" [panelSizes]="[5,95]" [gutterSize]="8">
  <ng-template pTemplate >
    <div style="height: 100%; border:1px solid #babfc7;min-width:350px;overflow:auto;">
      <p-panel header="Search Criteria" [toggleable]="smallScreen" [style]="{'height': '100%'}">
        <!-- Row 1-->
        <div class="p-fluid p-grid p-mt-1">
          <!--Select Date Range-->
          <div class="p-field p-col-12 p-md-12">
            <span class="p-float-label">
              <p-dropdown [(ngModel)]="selectedDateRange"
                          [options]="quickDateRanges" 
                          showClear="true"
                          inputid="selectedDateRange" 
                          optionLabel="title"
                          dataKey="id"
                          [autoDisplayFirst]="false"
                          (onChange)="onDateRangeChanged($event)"></p-dropdown>
              <label for="selectedDateRange">Select Date</label>
            </span>
          </div>
        </div>

        <!-- Row 2 -->
        <div class="p-fluid p-grid">
          <div class="p-field p-col-6">
            <span class="p-float-label">
              <p-calendar appendTo="body"
                          showIcon="true" 
                          dateFormat="dd/mm/yy"
                          inputId="fromDate"
                          name="fromDate"
                          [(ngModel)]="searchModel.fromDate"></p-calendar>
              <label for="fromDate">From Date</label>
            </span>
          </div>
          <div class="p-field p-col-6">
            <span class="p-float-label">
              <p-calendar appendTo="body"
                          showIcon="true" 
                          dateFormat="dd/mm/yy"
                          inputId="toDate"
                          name="toDate"
                          [(ngModel)]="searchModel.toDate"></p-calendar>
              <label for="toDate">To Date</label>
            </span>
          </div>
        </div>

        <!-- Row 3 -->
        <div class="p-fluid p-grid">
          <!--Select Employee Group-->
          <div class="p-field p-col-6 p-md-12">
            <span class="p-float-label">
              <p-dropdown [(ngModel)]="selectedGroup"
                          [options]="groups" 
                          showClear="true"
                          filter="true"
                          inputid="selectedGroup" 
                          optionLabel="name"
                          dataKey="id"
                          [autoDisplayFirst]="false"
                          (onChange)="onGroupChanged($event)"></p-dropdown>
              <label for="selectedGroup">Select Group</label>
            </span>
          </div>
          <!--Select Employees-->
          <div class="p-field p-col-6 p-md-12">
            <span class="p-float-label">
              <p-dropdown [(ngModel)]="selectedEmployee"
                          [options]="employees" 
                          showClear="true"
                          filter="true"
                          inputid="employee" 
                          optionLabel="name"
                          dataKey="id"
                          [autoDisplayFirst]="false"
                          (onChange)="onEmployeeChanged()"></p-dropdown>
              <label for="selectedEmployee">Select Employee</label>
            </span>
          </div>
        </div>

        <!-- Row 5 -->
        <div class="p-fluid p-grid">
          <!--Select Job Code-->
          <div class="p-field p-col-6 p-md-12">
            <span class="p-float-label">
              <p-dropdown [(ngModel)]="selectedJobCode"
                          [options]="jobCodes" 
                          showClear="true"
                          filter="true"
                          inputid="selectedJobCode" 
                          optionLabel="jobCodeNo"
                          dataKey="id"
                          [autoDisplayFirst]="false"
                          (onChange)="onJobCodeChanged()"></p-dropdown>
              <label for="selectedJobCode">Select Job Code</label>
            </span>
          </div>
          <!--Company-->
          <div class="p-field p-col-6 p-md-12">
            <span class="p-float-label">
              <p-dropdown [(ngModel)]="selectedEmployer"
                          [options]="employers" 
                          showClear="true"
                          filter="true"
                          inputid="selectedEmployer" 
                          optionLabel="employerName"
                          dataKey="id"
                          [autoDisplayFirst]="false"
                          (onChange)="onEmployerChanged()">
                <ng-template let-employer pTemplate="item">
                  <span *ngIf="!employer.active">(Inactive) </span>
                  <span>{{employer.employerName}}</span>
                </ng-template>
              </p-dropdown>
              <label for="selectedEmployer">Select Company</label>
            </span>
          </div>
        </div>

        <div class="p-fluid p-grid">
          <div class="p-field p-mb-0 p-col-12 p-text-right">
            <div class="p-d-inline-block">
              <button pButton pRipple label="Search" class="p-button" icon="pi pi-search" type="button" (click)="loadTimesheet()"></button>
            </div>
          </div>
        </div>
      </p-panel>

    </div>
  </ng-template>

  <ng-template pTemplate>
    <div style="height: 100%; width:100%;display:flex;flex-direction:column;min-height:0;">
      <ngx-spinner bdColor="rgba(128, 128, 128, 0.8)"
                  size="default"
                  color="#2f9cf2"
                  type="line-scale-pulse-out"
                  [name]="spinnerName"
                  [fullScreen]="false"><p style="color:white" >{{spinnerText}}</p></ngx-spinner>

      <ag-grid-angular  #topGrid
            style="width:100%;flex:1 1 auto;min-height:0;"
                        class="ag-theme-alpine pps-top-grid"
                        [context]="context"
                        [rowData]="timesheets"
                        [columnDefs]="gridHeaders"
                        [tooltipShowDelay]="0"
                        [gridOptions]="topOptions"
                        (gridReady)="onGridReady($event)"
                        (rowDoubleClicked)='onRowDblClicked($event)'
                        (rowClicked)='onRowClicked($event)'
                        [rowSelection]="{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }">
      </ag-grid-angular>
      <ag-grid-angular  #bottomGrid
            style="flex:0 0 50px; height: 50px;"
                        class="ag-theme-alpine pps-bottom-grid"
                        [headerHeight]="0"
                        [context]="context"
                        [rowData]="timesheetsTotal"
                        [columnDefs]="gridHeaders"
                        [gridOptions]="bottomOptions"
                        (gridReady)="onBottomGridReady($event)"
                        [rowStyle]="{ fontWeight: 'bold', backgroundColor: '#eeeeee'}"
                        [rowSelection]="{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }">
      </ag-grid-angular>
    </div>

  </ng-template>
</p-splitter>

</div>
